export default "__VITE_ASSET__c78ca2af__"